"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateExternalClaimPagePlain = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../../Types");
var components_1 = require("@athena-portal/components");
var SupportPortalTemplates_1 = require("../../../SupportPortalTemplates");
var react_datepicker_1 = require("react-datepicker");
var en_GB_1 = require("date-fns/locale/en-GB");
var CreateExternalClaimRequest_1 = require("../../../model/CreateExternalClaimRequest");
var moment = require("moment");
var CreateExternalClaimPagePlain = /** @class */ (function (_super) {
    __extends(CreateExternalClaimPagePlain, _super);
    function CreateExternalClaimPagePlain(props) {
        var _this = _super.call(this, props) || this;
        _this.supportPortalTemplates = new SupportPortalTemplates_1.SupportPortalTemplates();
        _this.handleOnSubmit = function (event) {
            event.preventDefault();
            if (_this.validate()) {
                var request = new CreateExternalClaimRequest_1.default();
                request.policyNumber = _this.props.params.policyNumber;
                request.policyVersionId = _this.props.params.policyVersionNumber;
                request.lossDate = moment(_this.state.lossDate).utc(true).format();
                _this.setState({ loadingClaim: true });
                _this.supportPortalService.createExternalClaim(_this.props.params.id, request)
                    .subscribe(function (response) {
                    _this.setState({
                        claimReference: response.claimReferenceNumber,
                        loadingClaim: false
                    });
                });
            }
            ;
        };
        _this.handleDateChange = function (date) {
            _this.setState({ lossDate: date });
        };
        _this.state = {
            lossDate: null,
            errors: []
        };
        return _this;
    }
    CreateExternalClaimPagePlain.prototype.componentDidMount = function () {
        var _this = this;
        this.setState({ loadingPolicyVersion: true });
        this.supportPortalService.getPolicyVersionDetails(this.props.params.id, this.props.params.policyNumber, this.props.params.policyVersionNumber)
            .subscribe(function (policyVersionDetails) {
            _this.setState({ policyVersionDetails: policyVersionDetails, loadingPolicyVersion: false });
        });
    };
    CreateExternalClaimPagePlain.prototype.render = function () {
        if (this.supportPortalTemplates.userHasRole(["Administrator", "Claims_Handler"])) {
            var loading = this.state.loadingPolicyVersion || this.state.loadingClaim;
            return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsx)(components_1.Overlay, { show: loading }), this.supportPortalTemplates.renderBackLink("Customer details", true, "/customers/".concat(this.props.params.id)), (0, jsx_runtime_1.jsxs)("form", { className: "row panel-border px-3", onSubmit: this.handleOnSubmit, children: [this.state.errors.length > 0 && (0, jsx_runtime_1.jsx)("div", { className: "col-12 alert alert-danger", children: this.renderErrors() }), (0, jsx_runtime_1.jsxs)("div", { className: "form-group col-12", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "amount", children: "Select loss date:" }), (0, jsx_runtime_1.jsx)(react_datepicker_1.default, { selected: this.state.lossDate, onChange: this.handleDateChange, dateFormat: "dd-MM-yyyy hh:mm a", showTimeSelect: true, timeFormat: "hh:mm a", locale: en_GB_1.default, className: "form-control" })] }), (0, jsx_runtime_1.jsx)("div", { className: "form-group col-12 clearfix", children: (0, jsx_runtime_1.jsx)("button", { type: "submit", className: "btn btn-primary mr-0", children: "Create claim" }) }), this.state.claimReference && ((0, jsx_runtime_1.jsxs)("div", { className: "alert alert-success col-12", children: [(0, jsx_runtime_1.jsx)("div", { children: "Claim successfully created" }), (0, jsx_runtime_1.jsx)("div", { children: this.state.claimReference })] }))] })] }));
        }
        else {
            return this.supportPortalTemplates.renderErrorPage();
        }
    };
    CreateExternalClaimPagePlain.prototype.renderErrors = function () {
        var errorsToRender = this.state.errors.map(function (error, index) { return ((0, jsx_runtime_1.jsx)("li", { children: error }, index)); });
        return (0, jsx_runtime_1.jsx)("ul", { className: "mb-1", children: errorsToRender });
    };
    CreateExternalClaimPagePlain.prototype.validate = function () {
        var _a, _b;
        var lossDate = this.convertDateToUkTimeZone(new Date(moment(this.state.lossDate, "DD/MM/YYYY, HH:mm:ss").toDate()), "DD-MM-YYYY HH:mm:ss");
        var currentDateUkTimezone = this.convertDateToUkTimeZone(new Date(), "DD-MM-YYYY HH:mm:ss");
        var minDate = this.convertDateToUkTimeZone((_a = this.state.policyVersionDetails) === null || _a === void 0 ? void 0 : _a.startDate, "DD-MM-YYYY HH:mm:ss");
        var maxDate = new Date(moment.parseZone((_b = this.state.policyVersionDetails) === null || _b === void 0 ? void 0 : _b.endDate, "YYYY-MM-DD HH:mm:ss").toDate());
        var lossDateIsBetweenStartDateAndEndDate = ((lossDate.getTime() > minDate.getTime()) && (lossDate.getTime() < maxDate.getTime()));
        var lossDateIsAfterCurrentMoment = lossDate.getTime() > currentDateUkTimezone.getTime();
        var errors = [];
        if (!this.state.lossDate) {
            errors.push("'Loss Date' is a mandatory field");
        }
        else if (lossDateIsAfterCurrentMoment) {
            errors.push("'Loss Date' can't be set in the future");
        }
        else if (!lossDateIsBetweenStartDateAndEndDate) {
            errors.push("'Loss Date' is not in range of the selected policy version");
        }
        if (this.state.claimReference) {
            errors.push("The claim " + this.state.claimReference + " has already been created for this policy version. Reload the page if you wish to create another claim.");
        }
        this.setState({
            errors: errors
        });
        return errors.length === 0;
    };
    CreateExternalClaimPagePlain.prototype.convertDateToUkTimeZone = function (date, format) {
        var convertedDateToUkTimeZone = moment(moment(date).toDate().toLocaleString("en-GB", { timeZone: "Europe/London", hour12: true }), format);
        return new Date(convertedDateToUkTimeZone.toDate());
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], CreateExternalClaimPagePlain.prototype, "supportPortalService", void 0);
    CreateExternalClaimPagePlain = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], CreateExternalClaimPagePlain);
    return CreateExternalClaimPagePlain;
}(React.Component));
exports.CreateExternalClaimPagePlain = CreateExternalClaimPagePlain;
exports.default = (0, components_1.withRouter)(CreateExternalClaimPagePlain);
//# sourceMappingURL=CreateExternalClaimPage.js.map